export default "__VITE_ASSET__AWnHdLjT__"